import Swal from 'sweetalert2/dist/sweetalert2.js';

const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default class Modal {
	
	constructor(config) {
		if (config)
			this.config = config;
	}

	with(element) {
		this.config = this.parseModalConfig(element);
		return this;
	}

	show() {
		let config = this.config;
		Swal.fire({
			title: config.title,
			text: config.text,
			icon: config.icon,
			html: config.html,
			showCancelButton: config.showCancelButton,
			showCloseButton: config.showCloseButton,
			confirmButtonText: config.confirmButtonText ? config.confirmButtonText : 'OK',
			cancelButtonText: config.cancelButtonText ? config.cancelButtonText : 'Abbrechen',
			customClass: {
				confirmButton: 'button-primary',
				container: config.customContainerClass
			},
			showClass: {
				popup: 'swal2-show',
				backdrop: 'swal2-backdrop-show',
				icon: 'swal2-icon-show'
			},
			didOpen: () => {
				if (config.showLoading)
					Swal.showLoading();
			},
			preConfirm: () => {
				if (!config.url)
					return;

				const form = document.querySelector('.swal2-html-container form');
				const formData = form ? new FormData(form) : new FormData();

				if (config.useAjax) {
					new Modal({
						showLoading: true
					}).show();
					this.ajaxRequest('post', config.url, formData);
				}
			}
		}).then((result) => {
			if (result.isConfirmed && config.redirectOnConfirm) {
				if (config.redirectOnConfirm == 'reload')
					window.location.reload();
				else window.location = config.redirectOnConfirm;
			}
		});
	}

	parseModalConfig(modalElement) {
		if (modalElement.innerHTML)
			modalElement.setAttribute('data-html', modalElement.innerHTML);
		modalElement.innerHTML = null;

		return {
			cancelButtonText: modalElement.getAttribute('data-cancel-text'),
			confirmButtonText: modalElement.getAttribute('data-confirm-text'),
			customContainerClass: modalElement.getAttribute('data-class'),
			icon: modalElement.getAttribute('data-icon'),
			html: modalElement.getAttribute('data-html'),
			showCancelButton: modalElement.getAttribute('data-show-cancel') === 'true',
			showCloseButton: modalElement.getAttribute('data-show-close') === 'true',
			showLoading: modalElement.getAttribute('data-show-loading') === 'true',
			text: modalElement.getAttribute('data-text'),
			title: modalElement.getAttribute('data-title'),
			url: modalElement.getAttribute('data-url'),
			useAjax: modalElement.getAttribute('data-ajax') === 'true',
			redirectOnConfirm: modalElement.getAttribute('data-redirect-on-confirm'),
			width: modalElement.getAttribute('width'),
			height: modalElement.getAttribute('height'),
		}
	}

	ajaxRequest(method, url, formData) {
		axios({
			method: method,
			url: url,
			data: formData,
		})
			.then((response) => {
				new Modal(response.data).show();
			})
			.catch((error) => {
				if (this.isModalResponse(error.response.data))
					new Modal(error.response.data).show();
				else if (this.isServerError(error.response))
					new Modal({ 
						icon: 'error', 
						text: error.response.data.message 
					}).show();
				else {
					new Modal({
						icon: 'error',
						text: 'Error while requesting data from server. Please reload the page and try again.'
					}).show();
					console.error(error);
				}
			});
	}

	isServerError(errorResponse) {
		return errorResponse.data && errorResponse.data.exception != null;
	}

	isModalResponse(data) {
		if (!data)
			return false;

		return data.title != null |
			data.text != null |
			data.html != null |
			data.showLoading != null;
	}
}
